import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { useQuery } from '../../hook/useQuery';

export const useServicePoints = () => {
    const { t, i18n } = useTranslation()
    const lang = i18n.language

    const { filterUrl } = useQuery();
    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1);
    const [queryString, setQueryString] = useState(' ')
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [allServicePoints, setAllServicePoints] = useState([]);
    const [servicePoints, setServicePoints] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/servicepoint?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/servicepoint?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.servicepoints?.data) {
            setServicePoints([...data?.data?.servicepoints?.data]);
            setTotal(data?.data?.servicepoints?.total);
            setLastPage(data?.data?.servicepoints?.last_page);
        }
    }, [data]);

    const fetchAllData = async () => {
        try {
            const response = await apiClient.get('/servicepoint')
            setAllServicePoints(response?.data)
        } catch (error) {

        }
    }

    const createServicePoint = async (newData) => {
        try {
            const response = await apiClient.post(`/servicepoint`, newData);
            mutate(`/servicepoint?perPage=${itemsPerPage}&page=${page}`);
            mutate(`/servicepoint`);
            return response.data
        } catch (error) {
            return error.response.data
        }
    };

    const updateServicePoint = async (id, updatedData) => {
        try {
            const response = await apiClient.put(`/servicepoint/${id}`, updatedData);
            mutate(`/servicepoint?perPage=${itemsPerPage}&page=${page}`);
            return response
        } catch (err) {
            return err.response.data
        }

    };

    const deleteServicePoint = async (id) => {
        try {
            const response = await apiClient.delete(`/servicepoint/${id}`);
            mutate(`/servicepoint?perPage=${itemsPerPage}&page=${page}`);
            mutate(`/servicepoint`);
            return response.data;
        } catch (err) {
            return err.response.data
        }

    };

    const getServicePointById = async (servicePointId) => {
        const response = await apiClient.get(`/servicepoint/${servicePointId}`);
        return response.data;
    };

    const updateStatus = async (id) => {
        try {
            const response = await apiClient.put(`/servicepoint/${id}/status`);
            mutate(`/servicepoint?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };

    const getObject = (object) => {
        const newObject = {
            name: object?.name?.[lang],
            address: object?.address?.[lang],
            area: object?.area?.name[lang],
            servicepoint_type: object?.servicepoint_type?.name?.[lang],
            phone: object?.phone,
            opening_time: object?.opening_time,
            closing_time: object?.closing_time,
            latitude: object?.latitude,
            longitude: object?.longitude,
            total_amount: object?.total_amount,

            status: object?.status == 0 ? t('properties.inactive') : t('properties.active')
        }
        return newObject;
    }

    const getExcelData = async () => {
        try {
            const queryString = filterUrl() || '';
            const url = queryString ? `/servicepoint?is_for_excel=1&${queryString}` : `/servicepoint?is_for_excel=1`;

            const response = await apiClient.get(url);
            const data = response?.data?.data?.servicepoints;

            const mapServicepoints = (data) => data.map(object => ({
                name: object?.name,
                servicepoint_number: object?.servicepoint_number,
                area: object?.area?.name,
                total_amount: object?.total_amount,
                servicepoint_type: object?.servicepoint_type?.name,
                is_deleted: object?.is_deleted,
            }));

            const servicepoints = Array.isArray(data)
                ? mapServicepoints(data)
                : Array.isArray(data?.data)
                    ? mapServicepoints(data.data)
                    : [];

            return servicepoints;

        } catch (err) {
            return err.response?.data || { error: 'An unexpected error occurred' };
        }
    };

    return {
        allServicePoints: Array.isArray(allServicePoints?.data?.servicepoints) ? allServicePoints?.data?.servicepoints : [],
        fetchData,
        fetchAllData,
        itemsPerPage,
        currentPage: page,
        servicePoints,
        isLoading: !error && !data,
        isError: error,
        total,
        lastPage,
        queryString,
        setPage,
        mutate,
        createServicePoint,
        updateServicePoint,
        deleteServicePoint,
        getServicePointById,
        updateStatus,
        getObject,
        setPerPge,
        getExcelData,
        setQueryString
    };
};